import type { ExploreContentResponsePageAllOfThreeContentItemContentOneOfReferencedTweetTweetAuthor } from './exploreContentResponsePageAllOfThreeContentItemContentOneOfReferencedTweetTweetAuthor';
import type { ExploreContentResponsePageAllOfThreeContentItemContentOneOfReferencedTweetTweetBasicInfo } from './exploreContentResponsePageAllOfThreeContentItemContentOneOfReferencedTweetTweetBasicInfo';
import type { ExploreContentResponsePageAllOfThreeContentItemContentOneOfReferencedTweetTweetEngagement } from './exploreContentResponsePageAllOfThreeContentItemContentOneOfReferencedTweetTweetEngagement';

/**
 * 참조된 트윗 요약 정보 (순환 참조 방지)
 */
export type ExploreContentResponsePageAllOfThreeContentItemContentOneOfReferencedTweetTweet = {
  /** 트윗 작성자 정보 */
  author?: ExploreContentResponsePageAllOfThreeContentItemContentOneOfReferencedTweetTweetAuthor;
  basicInfo?: ExploreContentResponsePageAllOfThreeContentItemContentOneOfReferencedTweetTweetBasicInfo;
  engagement?: ExploreContentResponsePageAllOfThreeContentItemContentOneOfReferencedTweetTweetEngagement;
};
